export default __webpack_public_path__ + "static/media/phonepeicon.9842a343.webp";